import { render, staticRenderFns } from "./DataPrincipal.vue?vue&type=template&id=d7e33392&scoped=true"
import script from "./DataPrincipal.vue?vue&type=script&lang=js"
export * from "./DataPrincipal.vue?vue&type=script&lang=js"
import style0 from "./DataPrincipal.vue?vue&type=style&index=0&id=d7e33392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e33392",
  null
  
)

export default component.exports